import styled from 'styled-components';

import { Button } from '../../components/Button';

export const ChoiceButton = styled(Button)`
    min-width: 100px;
`;
